<div class="otpInputWrapper">
  <!-- <div class="line">
    <div class="label" [HTMLTranslate]="'COMMON.ACCORDION_OTP.LABEL'"></div>
    <a
      (click)="sendOtp()"
      *ngIf="!hardware"
      class="send-again"
      [ngClass]="{ disabled: resendDisabled }">
      <span [HTMLTranslate]="'COMMON.ACCORDION_OTP.OTP_SEND_AGAIN'"></span>
    </a>
  </div> -->
  <div class="ic1-flex">
    <ng-container *ngIf="refreshOtp">
      <ng-container *ngIf="startTimer; else otpNoTimer">
        <ng-ui-kit-otp
          #ngUiKitOtp
          [icId]="'otp-input-' + (hardware ? 'hardware' : 'sms')"
          [type]="'number'"
          [title]="
            label || ('COMMON.ACCORDION_CONFIRMATION_CODE.LABEL' | translate)
          "
          [resendBtn]="resendBtnConfig"
          [disclaimerText]="error ? '' : disclaimerText"
          [error]="error"
          [length]="otpLength"
          (onChange)="onChange($event)"
          [timer]="timerSeconds"
          (timerEnd)="onTimerEnd()">
        </ng-ui-kit-otp>
      </ng-container>
      <ng-template #otpNoTimer>
        <ng-ui-kit-otp
          #ngUiKitOtp
          [icId]="'otp-input-' + (hardware ? 'hardware' : 'sms')"
          [type]="'number'"
          [title]="
            label || ('COMMON.ACCORDION_CONFIRMATION_CODE.LABEL' | translate)
          "
          [resendBtn]="resendBtnConfig"
          [disclaimerText]="error ? '' : disclaimerText"
          [error]="error"
          [length]="otpLength"
          (onChange)="onChange($event)">
        </ng-ui-kit-otp>
      </ng-template>
    </ng-container>
  </div>
  <div
    *ngIf="error && disclaimerText"
    class="ic1-input-disclaimer"
    [innerHTML]="disclaimerText"></div>
</div>
